import { render, staticRenderFns } from "./EnquiryMobileView.vue?vue&type=template&id=23828fd6&scoped=true&"
import script from "./EnquiryMobileView.vue?vue&type=script&lang=js&"
export * from "./EnquiryMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23828fd6",
  null
  
)

export default component.exports